export const ENDPOINT_PATHS = {
    chat: 'chat',
    sessions: 'sessions',
    messages: 'messages',
}

export const ENDPOINTS = {
    getChatSessions: "getChatSessions",
    postChatSession: "postChatSession",
    getChatSession: "getChatSession",
    postChatMessage: "postChatMessage",
}

export const ENDPOINT_METHODS = {
    getChatSessions: "GET",
    postChatSession: "POST",
    getChatSession: "GET",
    postChatMessage: "POST",
}

export const QUERYKEYS = ENDPOINTS;

// Convenience function to create the endpoint URLs for the chat API.
export const createEndpointUrl = function ({ endpoint, parameters, body }) {
    switch (endpoint) {
        case ENDPOINTS.getChatSessions:
            var root = ENDPOINT_PATHS.chat;

            return `${root}/${ENDPOINT_PATHS.sessions}`;
        case ENDPOINTS.getChatSession:
            if (!parameters) {
                throw new Error(`Empty parameters given for ${endpoint}`);
            }
            if (!parameters.sessionId) {
                throw new Error(`sessionId is required for ${endpoint}`);
            }

            var root = ENDPOINT_PATHS.chat;

            return `${root}/${ENDPOINT_PATHS.sessions}/${parameters.sessionId}`;
        case ENDPOINTS.postChatSession:
            var root = ENDPOINT_PATHS.chat;

            return `${root}/${ENDPOINT_PATHS.sessions}`;
        case ENDPOINTS.postChatMessage:
            if (!body) {
                throw new Error(`Empty body given for ${endpoint}`);
            }

            var root = ENDPOINT_PATHS.chat;

            return `${root}/${ENDPOINT_PATHS.messages}`;
        default:
            throw new Error(`Unknown endpoint: ${endpoint}`);
    }
}